import { useRef, useState } from 'react';
import { Divider, List, ListItem, ListItemButton, Stack, Typography, Button, Chip, Box, ClickAwayListener,  Popper, Paper, Badge, IconButton, Skeleton } from '@mui/material';
import { blue } from '@mui/material/colors';
import { useManagerNotificationsWs } from 'entities/notifications/notifications.hook';
import { NotificationDto } from '@sr/dto';
import { formatDateTime } from 'utils/date-format-helpers';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Link } from 'shared/ui/link-base';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useActionCreators } from 'shared/store';
import { workShiftReminderActions } from 'entities/salary/work-shifts/work-shift-reminder.slice';
import { parseReminderNotificationDate } from 'features/salary/work-shifts/work-shift-reminder.utils';


export const Notifications = () => {
  const { items, isLoading, count, readAll } = useManagerNotificationsWs();
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { showError } = useSnack();
  const { openReminder } = useActionCreators(workShiftReminderActions);

  const handleToggle = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };

  const handleReadAll = async () => {
    try {
      await readAll();
    } catch (e: unknown) {
      showError(extractNestJsErrorMessage(e), e);
    }
  };

  const handleNotificationClick = (notification: NotificationDto) => {
    const reminderDate = parseReminderNotificationDate(notification.message);
    if (!reminderDate) return;
    openReminder(reminderDate);
    setIsOpen(false);
  };


  return (<>
    <IconButton color='inherit' sx={{ margin: 1 }} onClick={handleToggle} ref={anchorRef}>
      <Badge badgeContent={count} color='warning'>
        <NotificationsIcon />
      </Badge>
    </IconButton>
    {<Popper
      open={isOpen}
      anchorEl={anchorRef.current}
      disablePortal>
      <ClickAwayListener onClickAway={handleToggle}>
        <Paper>

          <Box padding={1} >

            <Typography my={1}>Уведомления <Chip label={`${count} новых`} /></Typography>
            <Divider />
            {isLoading ?
              <Stack gap={1} direction={'column'}>
                <Skeleton variant='rectangular'/>
                <Skeleton variant='rectangular'/>
              </Stack>
              : 
              <NotificationsList notifications={items} onNotificationClick={handleNotificationClick}/>
            }
            <Box my={1} textAlign={'center'}>
              <Link to={'/notifications/'}>Все уведомления</Link>
            </Box>
            <Divider />
            <Button fullWidth onClick={handleReadAll}>Прочитать все</Button>
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper>}
  </>);
};


const NotificationsList = ({ notifications, onNotificationClick }: {notifications: NotificationDto[]; onNotificationClick: (notification: NotificationDto) => void}) => {
  return(
    <List sx={{ maxHeight: 300, overflow: 'auto' }} component={Stack}>
      {notifications.length === 0 && <ListItem>Нет новых уведомлений</ListItem>}
      {notifications.map((n) => (
        <ListItemButton
          key={n.id}
          onClick={() => onNotificationClick(n)}
          sx={n.isRead ? { marginY: '2px' } : { backgroundColor: blue[50], marginY: '2px' }}
        >
          <Stack direction={'column'}>
            <Typography>{n.message}</Typography>
            <Typography fontSize={12}>{formatDateTime(n.createdAt)}</Typography>
          </Stack>
        </ListItemButton>
      ))}
    </List>);
};
